import React from 'react';
import { AnalyticsEvent, useAnalytics } from '../Context/AnalyticsProvider';
import { useBalance } from '../Context/BalanceProvider';
import { useNavigate } from '../ProtectedRoute';
import { CircularProgress } from './CircularProgress';
import LoadingIcon from './LoadingIcon';

export const XPPill: React.FC = () => {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();
  const { isLoadingBalances, xpLevelInfo } = useBalance();

  if (!xpLevelInfo) {
    return null;
  }

  return (
    <div
      className="min-w-8 h-9 max-sm:h-7 p-2 cursor-pointer bg-blue-100 rounded-full border border-yellow-500/opacity-20 justify-start items-center gap-1.5 inline-flex"
      title={`Level ${xpLevelInfo.level}: ${xpLevelInfo.xpGainedInLevel}/${xpLevelInfo.xpRequiredForNextLevel} XP`}
      onClick={(e) => {
        trackEvent(AnalyticsEvent.XP_CLICKED);
        navigate('/my-stats');
        e.preventDefault();
      }}
    >
      {isLoadingBalances ? (
        <div className="h-full flex items-center justify-center">
          <LoadingIcon size={4} color="blue-600" />
        </div>
      ) : (
        <>
          <div className="w-6 h-6 relative">
            <img
              loading="lazy"
              src={require('../assets/icons/xp-coins.svg')}
              alt="XP"
              className="shrink-0 self-start w-4 aspect-square absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
            />
            <CircularProgress progress={xpLevelInfo.progressInLevel} />
          </div>
          <div className="text-center text-blue-600 text-base font-bold whitespace-nowrap">
            Lvl {xpLevelInfo.level}
          </div>
        </>
      )}
    </div>
  );
};
